import styled from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/toyotaTheme";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-3);
`;

export const SliderWrapper = styled.div`
    position: relative;
`;

export const SliderViewport = styled.div`
    display: flex;
    column-gap: var(--spacing-2);
    scroll-snap-type: x mandatory;
    overflow-x: scroll;
    scroll-behavior: smooth;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        display: none;
    }

    & > div {
        flex: 0 0 343px;

        @media screen and (min-width: ${breakpoints.md}) {
            flex: 0 0 352px;
        }

        @media screen and (min-width: ${breakpoints.xxl}) {
            flex: 0 0 205px;
        }

        @media screen and (min-width: ${breakpoints.xxxl}) {
            flex: 0 0 219px;
        }
    }
`;

export const ButtonWrapper = styled.div`
    display: flex;
    column-gap: var(--spacing-1);
`;

export const NavigationBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
